import { Suspense, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Loader from './components/layout/Loader';
import { COMPANY } from './data/siteData';
import { getMemory, saveMemory } from './memory';
import AppRoutes from './routes/AppRoutes';

const APP_MEMORY_SAMPLE = 'Graphify-style memory system demo entry';

const App = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      return undefined;
    }

    const existingMemories = getMemory();
    const hasSampleEntry = existingMemories.some((entry) => entry.text === APP_MEMORY_SAMPLE);

    if (!hasSampleEntry) {
      saveMemory(APP_MEMORY_SAMPLE);
    }

    console.info('Stored memories:', getMemory());
  }, []);

  return (
    <HelmetProvider>
      <div className="min-h-screen">
        <Suspense fallback={<Loader company={COMPANY} />}>
          <AppRoutes />
        </Suspense>
      </div>
    </HelmetProvider>
  );
};

export default App;
